var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1V1C10.314 1 13 3.686 13 7V7C13 10.314 10.314 13 7 13V13C3.686 13 1 10.314 1 7V7C1 3.686 3.686 1 7 1Z",
    stroke: "#E80A0F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 7.33333V4",
    stroke: "#E80A0F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99929 9.66667C6.90729 9.66667 6.83263 9.74133 6.83329 9.83333C6.83329 9.92533 6.90796 10 6.99996 10C7.09196 10 7.16663 9.92533 7.16663 9.83333C7.16663 9.74133 7.09196 9.66667 6.99929 9.66667",
    stroke: "#E80A0F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.4c1db592288206afa7741dacb4e41725.svg";
export { ForwardRef as ReactComponent };